<section class="p-2 p-md-4">


  <div class="card my-3" *ngIf="listaExperimentais.length>0">
    <h2 class="text-center p-3 border-bottom border-silver">Consulta Experimental
      <h4 class="text-center pt-3">Essas consultas não serão cobradas</h4>
    </h2>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let consulta of listaExperimentais" class="col-12 col-sm-6 col-md-4 p-2 d-flex align-items-center">
          <app-checkbox size='lg' (checkedChange)="selecionarExperimental($event,consulta)"  [label]="consulta.nome"
            [checked]="consulta.checked" [(disabled)]="consulta.disabled" ></app-checkbox>


          <!-- ng-template #popoverTemplate>
            <div *ngFor="let c of consulta.consultas">
              <div class="d-flex align-items-center">{{ c.nome }}</div>
            </div>
          </ng-template>
          <i [ngbPopover]="popoverTemplate" class="cursor-pointer mdi mdi-information text-info f-22 ml-lg-2 mb-3"></i -->



        </div>
      </div>
    </div>
  </div>

  <div class="card my-3" *ngIf="listaCombinadas.length>0">
    <h2 class="text-center p-3 border-bottom border-silver">Consulta Combinada
      <h4 class="text-center pt-3">É um combo de consultas criadas com uma seleção de consultas avulsas por um custo mais competitivo.</h4>
    </h2>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let consulta of listaCombinadas" class="col-12 col-sm-6 col-md-4 p-2 d-flex align-items-center">
          <app-checkbox size='lg' (checkedChange)="selecionarCombinada($event,consulta)"  [label]="consulta.nome"
            [checked]="consulta.checked" [(disabled)]="consulta.disabled" ></app-checkbox>


          <!-- ng-template #popoverTemplate>
            <div *ngFor="let c of consulta.consultas">
              <div class="d-flex align-items-center">{{ c.nome }}</div>
            </div>
          </ng-template>
          <i [ngbPopover]="popoverTemplate" class="cursor-pointer mdi mdi-information text-info f-22 ml-lg-2 mb-3"></i -->



        </div>
      </div>
    </div>
  </div>

  <div class="card my-3" *ngIf="listaCompostas.length>0">
    <h2 class="text-center p-3 border-bottom border-silver">Consulta Composta
      <h4 class="text-center pt-3">Conforme a necessidade do cliente, permite ao usuário criar um grupo de consultas avulsas a fim de automatizar o processo de escolha.</h4>
    </h2>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let consulta of listaCompostas" class="col-12 col-sm-6 col-md-4 p-2 d-flex align-items-center">
          <app-checkbox size='lg' (checkedChange)="selecionarComposta($event,consulta)" [label]="consulta.nome"
            [checked]="consulta.checked" [(disabled)]="consulta.disabled"></app-checkbox>

          <!-- ng-template #popoverTemplate>
            <div *ngFor="let c of consulta.consultas">
              <div class="d-flex align-items-center">{{ c.nome }}</div>
            </div>
          </ng-template>
          <i [ngbPopover]="popoverTemplate" class="cursor-pointer mdi mdi-information text-info f-22 ml-lg-2 mb-3"></i -->

        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" *ngIf="listaCreditos.length>0">
    <h2 class="text-center p-3 border-bottom border-silver">Consultas Crédito
      <h4 class="text-center pt-3">Confira a situação de fornecedores e clientes para tomar as decisões mais assertivas para o seu negócio.</h4>
    </h2>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let consulta of listaCreditos" class="col-12 col-sm-6 col-md-4 p-2">
          <app-checkbox size='lg' (checkedChange)="selecionarCredito($event,consulta)" [label]="consulta.nome"
            [checked]="consulta.checked" [(disabled)]="consulta.disabled"></app-checkbox>
        </div>
      </div>
      <div class="bg-light rounded mt-3" *ngIf="listaConsultasAdicionais.length > 0">
        <h3 class="px-3 pt-3 pb-2 border-bottom border-gray-200">Consultas Adicionais:</h3>
        <div class="p-2">
          <div class="row">
            <div *ngFor="let c of listaConsultasAdicionais" class="col-12 col-sm-6 col-md-4 p-2">
              <app-checkbox size='md' [label]="c.nome"
                [(checked)]="c.checked" (checkedChange)="selecionarInsumoCredito($event,c)"></app-checkbox>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card mb-3" *ngIf="usuario.permissoes.exibirConsultaAvulsa && listaConsultas.length>0">
    <h2 class="text-center p-3 border-bottom border-silver">Consultas Veiculares
      <h4 class="text-center pt-3">Dependendo da consulta selecionada, possibilita realizar uma consulta por meio de uma chave de entrada, como: Placa, Chassi, Renavam, Motor e etc.</h4>
    </h2>
    <div class="card-body">
      <div class="row">
        <div *ngFor="let consulta of listaConsultas" class="col-12 col-sm-6 col-md-4 p-2">
          <app-checkbox size='lg' (checkedChange)="selecionarConsulta($event,consulta)" [label]="consulta.nome"
            [(disabled)]="consulta.disabled" [(checked)]="consulta.checked"></app-checkbox>
        </div>
      </div>
    </div>
  </div>







  <app-form-realizar-consulta  (submit)="realizarConsulta($event)" [totalConsultas]="totalConsultas"
    [hidden]="totalConsultas==0" [(formView)]="formView" [ufObrigatorio]="ufObrigatorio" [ufOpcional]="ufOpcional"></app-form-realizar-consulta>

</section>
